import { apiClient } from "./client";

export async function uploadAsset(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await apiClient.post("/v1/inspection-evidences/assets", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data?.data || res.data;
}

export async function createEvidence(payload) {
  const res = await apiClient.post("/v1/inspection-evidences", payload);
  return res.data;
}

export async function listEvidences(params = {}) {
  const res = await apiClient.get("/v1/inspection-evidences", { params });
  return res.data?.data || [];
}

export async function getEvidence(uid) {
  const res = await apiClient.get(`/v1/inspection-evidences/${uid}`);
  return res.data;
}
